import { FC } from "react";

import cn from "classnames";
import { Image, Button, Link } from "capitalrx-components-2.0/lib/general";
import { Logo } from "capitalrx-components-2.0/lib/general";
import { NavbarProps } from "./NavbarProps";
import { contactUsPressed } from "../../utils/contactUsPressed";
import AdvantageLogo from "@/static/images/advantage-logo.svg?url";
import { useGroupNumber } from "@/utils/useGroupNumber";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

import styles from "./Navbar.module.scss";


const Navbar: FC<NavbarProps> = ({ className }: NavbarProps) => {
  const navbarContainerClasses = cn(styles["navbarContainer"], className);
  const groupNumber = useGroupNumber();

  const homeURL = groupNumber ? `/${groupNumber}` : "/";

  return (
    <div className={navbarContainerClasses}>
      <Link to={homeURL} className={styles.navbarLeftSide} testId="advantage-home-link">
        <Image src={AdvantageLogo} alt="Capital Rx Advantage Savings" className={styles.advantageLogo} aria-hidden="true" />
        <span>Capital Rx Advantage Savings</span>
      </Link>
      <div className={styles.navbarRightSide}>
        <Paragraph className={styles.poweredBy}>
          Powered by
        </Paragraph>
        <Link to="https://cap-rx.com/" className={styles.linkToCorporate} testId="capital-rx-home-link">
          <span aria-hidden="true">
            <Logo name="caprx-horizontal" testId="capital-rx-logo-footer" className={styles.capitalrxLogo} />
          </span>
          <span className="companyName">Capital Rx</span>
        </Link>
        <Button className={styles.contactUsButton} appearance="primary" key={0} onClick={contactUsPressed} testId="contact-us-link">
          CONTACT US
        </Button>
      </div>
    </div>
  );
};

export default Navbar;
